class ProductSpecifications extends HTMLElement {
  constructor() {
    super();
    this.tableWrapper = this.querySelector(
      ".product-specifications__table-wrapper"
    );
    this.moreButton = this.querySelector(
      ".product-specifications__more-button"
    );
    this.init();
  }

  init() {
    if (!this.tableWrapper || !this.moreButton) return;

    // Check if content needs the more button
    const isContentOverflowing = () => {
      const maxHeight = parseInt(
        getComputedStyle(this.tableWrapper).maxHeight,
        10
      );
      return this.tableWrapper.scrollHeight > maxHeight;
    };

    // Show/hide more button based on content height
    if (isContentOverflowing()) {
      this.moreButton.classList.add("visible");
    }

    // Toggle expand/collapse on button click
    this.moreButton.addEventListener("click", () => {
      const isExpanded = this.tableWrapper.classList.toggle("expanded");
      this.moreButton.classList.toggle("expanded", isExpanded);

      // Update button text
      const buttonText = this.moreButton.querySelector("span");
      if (buttonText) {
        buttonText.textContent = isExpanded
          ? "Show less"
          : "Show more specifications";
      }
    });

    // Update on resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!this.tableWrapper.classList.contains("expanded")) {
          this.moreButton.classList.toggle("visible", isContentOverflowing());
        }
      }, 250);
    });
  }
}

// Only define the custom element if it hasn't been defined yet
if (!customElements.get("product-specifications")) {
  try {
    customElements.define("product-specifications", ProductSpecifications);
  } catch (error) {
    // console.warn("ProductSpecifications element has already been defined");
  }
}
